import * as s from "~/lib/normalize/schema";
import { DepartmentSchema, LocationSchema } from "~/apps/shared/apis/schemas";

/**
 * Products
 */
export const ProductSchema = s.obj({
  id: s.field(),
  name: s.field(),
  type: s.field(),
  organizationId: s.alias("organization_id"),
  locationId: s.alias("location_id"),
  price: s.currency(),
  group: s.obj({
    id: s.field(),
    name: s.field(),
    organizationId: s.field(),
    createdAt: s.field(),
    updatedAt: s.field(),
  }),
  categoryId: s.alias("category_id"),
  category: s.obj({
    id: s.field(),
    name: s.field(),
    organizationId: s.field(),
    createdAt: s.field(),
    updatedAt: s.field(),
  }),
  groupId: s.alias("group_id"),
  priority: s.field(),
  maximumAmount: s.alias("maximum_amount", s.currency()),
  createdAt: s.alias("created_at", s.date()),
  updatedAt: s.alias("updated_at", s.date()),
});

export const ProductListSchema = s.list(ProductSchema);

export const ProductRequest = s.obj({
  id: s.field(),
  name: s.field(),
  type: s.field(),
  price: s.currency(),
  organizationId: s.alias("organization_id"),
  locationId: s.alias("location_id"),
  categoryId: s.alias("category_id"),
  groupId: s.alias("group_id"),
  priority: s.field(),
});


// Product groups and Product categories
export const ProductSegmentSchema = s.obj({
  id: s.field(),
  name: s.field(),
  organizationId: s.alias("organization_id"),
  createdAt: s.alias("created_at", s.date()),
  updatedAt: s.alias("updated_at", s.date()),
});

export const ProductSegmentListSchema = s.list(ProductSegmentSchema);

export const ProductSegmentReqSchema = s.obj({
  name: s.field(),
});

/**
 * Sales Response
 */

export const SaleProductResponse = s.obj({
  description: s.field(),
  price: s.currency(),
  product: s.field(),
  quantity: s.field(),
});

export const SaleProductResponseList = s.list(SaleProductResponse);

export const SaleSchema = s.obj({
  id: s.field(),
  poNumber: s.alias("po_number"),
  company: s.field(),
  description: s.field(),
  status: s.field(),
  number: s.field(),
  numberSixDigit: s.alias("number_six_digit"),
  items: SaleProductResponseList,
  price: s.currency(),
  locationId: s.alias("location_id"),
  location: LocationSchema,
  paymentId: s.alias("payment_id"),
  paymentType: s.alias("payment_type"),
  driverPhone: s.alias("driver_phone"),
  driverLicense: s.alias("driver_license"),
  driverState: s.alias("driver_state"),
  additionalFields: s.alias("additional_fields"),
  receiptUrl: s.alias("receipt_url"),
  arrivalTime: s.alias("arrival_time", s.date()),
  checkInTime: s.alias("check_in_time", s.date()),
  notificationTime: s.alias("notification_time", s.date()),
  checkoutTime: s.alias("checkout_time", s.date()),
  department: DepartmentSchema,
  shift: s.field(),
  completedAt: s.alias("completed_at", s.date()),
  createdAt: s.alias("created_at", s.date()),
  updatedAt: s.alias("updated_at", s.date()),
});

export const SaleListSchema = s.list(SaleSchema);

export const SalesTotalsSchema = s.obj({
  totalCountOfSales: s.alias("total_count_of_sales"),
  totalAmountOfSales: s.alias("total_amount_of_sales", s.currency()),
});

/**
 * Sale Request
 */
export const SaleRequestProductItem = s.obj({
  productId: s.alias("product_id"),
  quantity: s.field(),
  price: s.currency(),
  description: s.field(),
});
export const SaleRequestProductList = s.list(SaleRequestProductItem);

export const SaleRequest = s.obj({
  id: s.field(),
  poNumber: s.alias("po_number"),
  company: s.field(),
  description: s.field(),
  organizationId: s.alias("organization_id"),
  locationId: s.alias("location_id"),
  departmentId: s.alias("department_id"),
  shift: s.alias("shift_id"),
  paymentType: s.alias("payment_type"),
  saleProducts: s.alias("sale_products", SaleRequestProductList),
  additionalFields: s.alias("additional_fields"),
  arrivalTime: s.alias("arrival_time"),
  checkInTime: s.alias("check_in_time"),
});

export const SaleRequestPayCode = s.obj({
  code: s.field(),
});

export const SaleRequestPayCheckout = s.obj({
  driverPhone: s.alias("driver_phone"),
});

export const SaleRequestPayOther = s.obj({
  type: s.field(),
});

/**
 * Additional fields Request
 */
export const AdditionalFieldItem = s.obj({
  id: s.field(),
  name: s.field(),
  isRequired: s.alias("is_required"),
  confirmRequired: s.alias("confirm_required"),
  fieldType: s.alias("field_type"),
  locationId: s.alias("location_id"),
  description: s.field(),
  organizationId: s.alias("organization_id"),
  priority: s.field(),
  showInTable: s.alias("show_in_table"),
  createdAt: s.alias("created_at", s.date()),
  updatedAt: s.alias("updated_at", s.date()),
});
export const AdditionalFieldListSchema = s.list(AdditionalFieldItem);

export const AdditionalFieldRequest = s.obj({
  name: s.field(),
  fieldType: s.alias("field_type"),
  isRequired: s.alias("is_required"),
  locationId: s.alias("location_id"),
  description: s.field(),
});

/**
 *  Sale Message Request
 */
export const SaleSendEmailRequest = s.obj({
  email: s.field(),
});

export const SaleSendSmsRequest = s.obj({
  phone: s.field(),
});
